
<template>
  <el-dialog class="dialog-change-tags" title="批量下架" :visible="visible" @close="close" @update:visible="setVisible" width="450px">
    <ConfigForms ref="form" :form-items="formItems"></ConfigForms>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="close">取 消</el-button>
      <el-button type="primary" size="small" @click="sure">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import ConfigForms from '@/components/config-forms/index.vue';
import { passTypes } from '../../../../config';

export default {
  name: 'TwitterAdminClientDialogSetRemoved',
  components: { ConfigForms },
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      formItems: [
        { label: '状态', key: 'pass', type: 'select', required: true, options: passTypes },
        { label: '审核原因', key: 'reason', type: 'textarea' },
      ]
    };
  },

  mounted() {
    
  },

  methods: {
    setVisible(visible) {
      this.$emit('update:visible', visible)
    },
    close() {
      this.setVisible(false)
      this.$emit('close')
    },
    async sure() {
      try {
        const r = await this.$refs.form.validate()
        this.$emit('submit', r)
      } catch (error) {
        
      }
    }
  },
};
</script>
